import { LessonStatus } from '../types/lesson';
import { GroupType } from '../types/others';

export const getLessonStatusLabel = (lessonStatus: LessonStatus | undefined): string => {
  switch (lessonStatus) {
    case 'readyToPlay':
      return 'Ready to play';
    case 'minimal':
      return 'Minimal';
    default:
      return 'Unknown';
  }
};

export const getLessonUploadFileName = (groupType: GroupType) => {
  let prefix;
  switch (groupType) {
    case 'layer':
      prefix = 'dl';
      break;
    case 'pack':
      prefix = 'lpl';
      break;
    case 'trial_lesson':
      prefix = 'tl';
      break;
    default:
      prefix = 'ol';
  }

  const randomString = Math.random().toString(36).substring(2, 10);
  return prefix?.concat('-', randomString);
};
